import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetsService } from 'src/app/shared/services/assets.service';
import { Debt, DebtsService } from 'src/app/shared/services/debts.service';

import * as _moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { Instrument, InstrumentsService } from 'src/app/shared/services/instruments.service';
const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-debt-detail',
  templateUrl: './debt-detail.component.html',
  styleUrls: ['./debt-detail.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class DebtDetailComponent implements OnInit {
  loading: boolean = false;
  loadingInstruments: boolean = false;
  saving: boolean = false;
  deleting: boolean = false;
  isEdit: boolean = false;
  debtId: string = "";
  debt: Debt = new Debt();
  instruments: Instrument[] = new Array<Instrument>();
  instrumentsDisplayColumns: string[] = ['type', 'term', 'allocation', 'rate'];
  deleteInstrumentIndex: number = 0;

  constructor(public dialog: MatDialog, private route: ActivatedRoute, private router: Router, private debtsSvc: DebtsService, private assetSvc: AssetsService, private instrumentsSvc: InstrumentsService, private location: Location, private formBuilder: FormBuilder, private _snackBar: MatSnackBar) {
    this.loading = true;
    this.loadingInstruments = true;
    this.route.paramMap.subscribe((params) => {
      if (params.has('debtId')) {
        var id = params.get('debtId');
        if (id != 'create') {
          this.debtId = id as string;
          this.isEdit = true;
        }
      }
    });
  }

  debtForm = this.formBuilder.group({
    debtNameCtl: ['', [Validators.required]],
    debtMonthsCtl: [0, [Validators.required]],
    debtBorrowedCtl: [0, [Validators.required]],
    debtBorrwedAtCtl: [moment(), Validators.required],
    debtIsExploratoryCtl: [true],
  });

  ngOnInit(): void {
    if (this.isEdit == true) {
      this.loading = true;
      this.loadDebt();
      this.loadInstruments();
    } else {
      this.displayDebt();
    }
  }

  onSave() {
    this.saving = true;
    this.debtForm.disable();
    var request = this.mapFormToDebt(this.debt);

    if (this.isEdit) {
      this.debtsSvc.updateDebt(request)
        .subscribe({
          next: (data: Debt) => {
            this.debt = data;
            this.displayDebt();
          },
          error: (error: HttpErrorResponse) => {
            this.saving = false;
            this._snackBar.open("Error occured updating your debt entry, please try again later.", undefined, { duration: 5000 })
            this.debtForm.enable();
            this.saving = false;
          }
        });
    } else {
      this.debtsSvc.createDebt(request)
        .subscribe({
          next: (data: Debt) => {
            this.debt = data;
            this.displayDebt();
          },
          error: (error: HttpErrorResponse) => {
            this.saving = false;
            this._snackBar.open("Error occured creating your debt entry, please try again later.", undefined, { duration: 5000 })
            this.debtForm.enable();
            this.saving = false;
          }
        });
    }
  }

  onCancel() {
    this.location.back();
  }

  onDelete() {
    let dialogRef = this.dialog.open(DialogDeleteDebtDialog);

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.deleting = true;
        this.deleteInstrumentIndex = 0;
        this.deleteInstrumentsAndDebt();
      }
    });
  }

  deleteInstrumentsAndDebt() {
    console.log(this.deleteInstrumentIndex);
    console.log(this.instruments.length);
    if (this.deleteInstrumentIndex < this.instruments.length) {
      this.instrumentsSvc.deleteInstrument(this.instruments[this.deleteInstrumentIndex].Id).subscribe({
        next: (x) => {
          this.deleteInstrumentIndex = this.deleteInstrumentIndex + 1;
          this.deleteInstrumentsAndDebt();
        },
        error: (error: HttpErrorResponse) => {
          this.deleting = false;
          this._snackBar.open("Error occured deleting your instruement attached to your debt , please try again later.", undefined, { duration: 5000 })
        }
      });
    } else {
      this.debtsSvc.deleteDebt(this.debt).subscribe({
        next: (x) => {
          this.deleting = false;
          this.onCancel();
        },
        error: (error: HttpErrorResponse) => {
          this.deleting = false;
          this._snackBar.open("Error occured deleting your debt, please try again later.", undefined, { duration: 5000 })
        },
      });
    }
  }

  niceTerm(months: number): string {
    return _moment.duration(months, 'months').humanize();
  }

  private loadDebt() {
    this.debtsSvc.getDebt(this.debtId)
      .subscribe(resp => {
        this.debt = resp;
        this.displayDebt();
      });
  }

  private loadInstruments() {
    this.instrumentsSvc.getInstrumentsByDebt(this.debtId)
      .subscribe({
        next: (data) => {
          this.instruments = data;
          this.loadingInstruments = false;
        },
        error: (err: HttpErrorResponse) => {
          if (err.status === 404) {
            this.loadingInstruments = false;
          } else {
            throw err;
          }
        }
      });
  }

  private displayDebt() {
    this.mapDebtToFrom(this.debt);
    this.debtForm.markAsPristine();
    this.debtForm.enable();
    this.saving = false;
    this.loading = false;
  }

  private mapDebtToFrom(d: Debt): void {
    this.debtForm.controls.debtBorrowedCtl.setValue(d.principalBorrowed);
    this.debtForm.controls.debtBorrwedAtCtl.setValue(moment(d.principalPayoutAt));
    this.debtForm.controls.debtMonthsCtl.setValue(d.durationMonths);
    this.debtForm.controls.debtNameCtl.setValue(d.name);
    this.debtForm.controls.debtIsExploratoryCtl.setValue(d.isExploratory);
  }

  private mapFormToDebt(d: Debt): Debt {
    d.durationMonths = this.debtForm.value.debtMonthsCtl as number;
    d.name = this.debtForm.value.debtNameCtl as string;
    d.principalBorrowed = this.debtForm.value.debtBorrowedCtl as number;
    d.principalPayoutAt = moment(this.debtForm.value.debtBorrwedAtCtl).toDate();
    d.isExploratory = this.debtForm.value.debtIsExploratoryCtl as boolean;
    return d;
  }
}

@Component({
  selector: 'debt-detail-delete-dialog',
  templateUrl: 'debt-detail-delete-dialog.component.html',
})
export class DialogDeleteDebtDialog {
  constructor(public dialogRef: MatDialogRef<DialogDeleteDebtDialog>) { }
}